const defaultStoreName = 'navigation';

const getNavigation = (state, storeName = defaultStoreName) => (state && state[storeName]) || {};
const getNavigationCategoryTags = (state, storeName = defaultStoreName) =>
    getNavigation(state, storeName).categoryTagsData || {};
const getNavigationCategoryBaseUrl = (state, storeName = defaultStoreName) =>
    getNavigation(state, storeName).categoryTagsBaseUrl || '';
const getNavigationCategoryApiKey = (state, storeName = defaultStoreName) =>
    getNavigation(state, storeName).categoryTagsApiKey || '';
const getNavigationLinkUrl = (state, storeName = defaultStoreName) =>
    getNavigation(state, storeName).linkUrl || '';
const getCategoryPlpSize = (state, storeName = defaultStoreName) =>
    getNavigation(state, storeName).categoryProdSize || '';

const getActiveCategoryTags = (state, storeName = defaultStoreName) =>
    getNavigation(state, storeName).activeCategoryTagsData || [];
const getRelatedKeywords = (state, storeName = defaultStoreName) =>
    getNavigation(state, storeName).relatedKeywords || [];
const getBaseProductList = (state, storeName = defaultStoreName) =>
    getNavigation(state, storeName).baseProductCodes || [];
const getSearchKeyword = (state, storeName = defaultStoreName) =>
    getNavigation(state, storeName).searchKeywords || '';
const getProductList = (state, storeName = defaultStoreName) =>
    getNavigation(state, storeName).productList || '';
const getCategoryPageTags = (state, storeName = defaultStoreName) =>
    getNavigation(state, storeName).categoryPageTags || [];
const getKeywordForPagination = (state, storeName = defaultStoreName) =>
    getNavigation(state, storeName).additionalPagination.keyword;
const getCategoryForPagination = (state, storeName = defaultStoreName) =>
    getNavigation(state, storeName).additionalPagination.category;
const getCategoryPagination = (state, storeName = defaultStoreName) =>
    getNavigation(state, storeName).additionalPagination || {};
const getTotalPage = (state, storeName = defaultStoreName) =>
    getCategoryPagination(state, storeName).totalPages || 0;
const getCurrentPage = (state, storeName = defaultStoreName) =>
    getCategoryPagination(state, storeName).currentPage || 0;
const getServiceUrl = (state, serviceType, storeName = defaultStoreName) => {
    return getNavigation(state, storeName)[serviceType];
};
const getInterestSelectionComponents = (state, storeName = defaultStoreName) =>
    getNavigation(state, storeName).interestSelectionComponents;
const getInterestSelectionQuestionContent = (state, storeName = defaultStoreName) =>
    getNavigation(state, storeName).interestSelectionComponentData;
const getInterestSelectionMaxItemsToDisplay = (state, storeName = defaultStoreName) =>
    getNavigation(state, storeName).interestSelectionComponentData.maxNumberOfItemsToDisplay;
const getInterestSelectionKeywords = (state, storeName = defaultStoreName) =>
    getNavigation(state, storeName).interestSelectionKeywords || {};

export default {
    getNavigation,
    getNavigationCategoryTags,
    getNavigationCategoryBaseUrl,
    getNavigationCategoryApiKey,
    getNavigationLinkUrl,
    getActiveCategoryTags,
    getRelatedKeywords,
    getSearchKeyword,
    getProductList,
    getCategoryPageTags,
    getKeywordForPagination,
    getCategoryForPagination,
    getTotalPage,
    getCurrentPage,
    getServiceUrl,
    getCategoryPlpSize,
    getBaseProductList,
    getInterestSelectionComponents,
    getInterestSelectionQuestionContent,
    getInterestSelectionMaxItemsToDisplay,
    getInterestSelectionKeywords,
};
